<template>
  <!-- :key="this.$route.fullPath" 会导致路由跳转刷新页面问题 -->
  <router-view />
</template>

<script>
export default {
  created() {
    window.selectEditorImage = (id) => {
      // console.log('window.selectEditorImage', id);
      this.$bus.$emit(`selectEditorImage_${id}`);
    };
    window.onresize = () => {
      this.$bus.$emit("windowResize");
    };
  },
};
</script>

<style lang="scss" scoped>
@import url("@/assets/css/adm.scss");
.adm-layout {
  width: 100%;
  height: 100%;
  min-width: 1280px;
  // min-height: 800px;
  overflow-y: scroll;
  overflow-x: hidden;

  // display: flex;
  // align-items: flex-start;

  .adm-content {
    display: flex;
    align-items: flex-start;
    // height: calc(100vh - 64px);
  }

  .adm-left {
    position: absolute;
    width: 130px;
    height: calc(100% - 64px);
    display: flex;
    flex-direction: column;
    left: 0;
    top: 64px;
    // background-color: #191931;
    color: #191931;
    padding-right: 5px;
    z-index: 1;
    // border-right: 1px solid #e7e7e8;

    .adm-left-logo {
      width: 100%;
      height: 82px;
      display: flex;
      align-items: center;
      justify-content: center;

      .logo-img {
        width: 32px;
        height: 32px;
        cursor: pointer;
      }
    }

    .adm-menus {
      width: 100%;
      // height: 0;
      flex-grow: 1;
      overflow: auto;

      &::-webkit-scrollbar-track {
        -webkit-box-shadow: none;
        background-color: transparent;
        border-radius: 3px;
      }

      &::-webkit-scrollbar {
        width: 0;
        height: 6px;
        background-color: transparent;
      }

      &::-webkit-scrollbar-thumb {
        border-radius: 5px;
        background-color: rgba(0, 0, 0, 0.2);
      }

      .menu-item {
        .menu-item-parent {
          height: 50px;
          margin-bottom: 5px;
          display: flex;
          align-items: center;
          cursor: pointer;
          user-select: none;

          &:hover {
            background-color: rgba($color: #ffffff, $alpha: 0.05);
            .menu-item-icon {
              background-position: 20px 0;
            }

            .menu-item-text {
              // color: #191931;
              color: #0366ff;
            }
          }

          &.active {
            // background-color: rgba($color: #ffffff, $alpha: 0.9);

            .menu-item-icon {
              background-position: 20px 0;
            }

            .menu-item-text {
              // color: #191931;
              color: #0366ff;
            }
          }

          .menu-item-icon {
            width: 20px;
            height: 20px;
            margin-left: 20px;
            background-size: 40px 20px;

            &.home {
              background-image: url(https://image.renrenjiang.cn/jy_star/icons/menu/icon_menu_home.png);
            }

            &.planet {
              background-image: url(https://image.renrenjiang.cn/jy_star/icons/menu/icon_menu_planet.png?t=1);
            }

            &.page {
              background-image: url(https://image.renrenjiang.cn/jy_star/icons/menu/icon_menu_page.png?t=1);
            }

            &.content {
              background-image: url(https://image.renrenjiang.cn/jy_star/icons/menu/icon_menu_content.png?t=1);
            }

            &.orders {
              background-image: url(https://image.renrenjiang.cn/jy_star/icons/menu/icon_menu_orders.png?t=1);
            }

            &.member {
              background-image: url(https://image.renrenjiang.cn/jy_star/icons/menu/icon_menu_member.png?t=1);
            }

            &.tools {
              background-image: url(https://image.renrenjiang.cn/jy_star/icons/menu/icon_menu_tools.png?t=1);
            }

            &.marketing {
              background-image: url(https://image.renrenjiang.cn/jy_star/icons/menu/icon_menu_marketing.png?t=1);
            }

            &.analysis {
              background-image: url(https://image.renrenjiang.cn/jy_star/icons/menu/icon_menu_analysis.png?t=1);
            }

            &.setting {
              background-image: url(https://image.renrenjiang.cn/jy_star/icons/menu/icon_menu_setting.png?t=1);
            }
          }

          .menu-item-text {
            width: 0;
            flex-grow: 1;
            margin: 0 5px;
            line-height: 20px;
            font-size: 14px;
            // color: rgba($color: #ffffff, $alpha: 0.8);
          }

          .menu-item-arrow {
            width: 20px;
            height: 20px;
            margin-right: 4px;
            background-size: 20px;
            background-image: url(https://image.renrenjiang.cn/jy_star/icons/menu/icon_menu_arrow_right.png?t=1);
          }

          .menu-item-arrow-right {
            transform: rotate(-90deg);
            transform-origin: center;
          }
        }

        .menu-item-children {
          transition: all 0.3s;
          overflow: hidden;

          &.unexpend {
            height: 0 !important;
          }

          .child-item {
            margin-bottom: 5px;
            padding-left: 45px;
            box-sizing: border-box;
            line-height: 50px;
            font-size: 14px;
            cursor: pointer;
            // color: rgba($color: #ffffff, $alpha: 0.8);

            &.active {
              // background-color: rgba($color: #ffffff, $alpha: 0.9) !important;
              color: #0366ff !important;
            }

            &:hover {
              // color: #ffffff;
              color: #0366ff;
              background-color: rgba($color: #ffffff, $alpha: 0.05);
            }
          }
        }
      }
    }
  }

  .adm-right {
    width: calc(100vw - 130px);
    margin-left: 130px;
    // width: 0;
    height: 100%;
    // flex-grow: 1;

    display: flex;
    flex-direction: column;
    // overflow-y: scroll;

    // .adm-head {
    //   width: 100%;
    //   height: 60px;
    //   background-color: #ffffff;
    //   box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.1);
    // }

    .adm-body {
      // width: 100%;
      // height: 0;
      // flex-grow: 1;
      // overflow: auto;
    }
  }
}
</style>
